"use client";

import { c as _c } from "react/compiler-runtime";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { useClientOnly } from "library/ClientOnly";
import { subscribeToMousePosition } from "library/mouse-position";
import { useIsSmooth } from "library/Scroll";
import { useAnimation } from "library/useAnimation";
import { useRef, useState } from "react";
import TallLinesSVGFaded from "./lines-tall-faded.inline.svg";
import LinesSVG from "./lines.inline.svg";
import { withComponent } from "library/styled/withComponent";
import { linesColorVar, LinesContainer, Layer, FaintLayer as FaintLayer___raw, SpotlightLayer as SpotlightLayer___raw, WaveLayer as WaveLayer___raw, LineIt } from "data:text/javascript;base64,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";
gsap.registerPlugin(ScrollTrigger);
// idle wave: an angled, feathered band of light that drifts across, revealing lines as it passes
const WAVE_ENABLED = true; // flip to true to bring the ambient idle wave back
const WAVE_DURATION = 2.5;
const WAVE_INTERVAL = 6;
const QUICK_TO = {
  duration: 0.4,
  ease: "power2.out"
};
const SHOW = {
  duration: 1,
  ease: "sine.inOut"
};
const HIDE = {
  duration: 1,
  ease: "sine.inOut"
};
// cursor-reactive columns: each line + its diamond nudges vertically away from the pointer
const TIPS_ENABLED = true;
const TIP_RADIUS = 80; // viewBox units — how close the cursor must be to a tip to affect it
const TIP_STRENGTH = 2; // fraction of the cursor→tip vertical distance applied as offset
const TIP_MAX = 40; // viewBox units — max vertical nudge
const TIP_LERP = 0.35; // 0–1 smoothing per frame (lower = laggier)
// svg viewBox, used to map pointer coordinates into the lines' own coordinate space
const VIEWBOX_W = 1396;
const VIEWBOX_H = 772;
const clamp = (min: number, value: number, max: number) => Math.max(min, Math.min(max, value));
export default function Lines(t0) {
  const $ = _c(38);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    color,
    fill: t2,
    intenseSpotlight: t3
  } = t1;
  const fill = t2 === undefined ? "aspect" : t2;
  const intenseSpotlight = t3 === undefined ? true : t3;
  const containerRef = useRef(null);
  const spotlightRef = useRef(null);
  const waveRef = useRef(null);
  const isUsingMouse = useClientOnly(useIsSmooth(), false);
  const [inView, setInView] = useState(false);
  const Artwork = fill === "height" ? TallLinesSVGFaded : LinesSVG;
  let t4;
  let t5;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      let st;
      try {
        st = ScrollTrigger.create({
          trigger: container,
          start: "top bottom+=200px",
          end: "bottom top-=200px",
          onToggle: self => setInView(self.isActive)
        });
      } catch {
        return;
      }
      setInView(st.isActive);
      return () => st?.kill();
    };
    t5 = [];
    t6 = {
      recreateOnResize: true,
      updateBehavior: "kill"
    };
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t4 = $[2];
    t5 = $[3];
    t6 = $[4];
  }
  useAnimation(t4, t5, t6);
  let t7;
  if ($[5] !== inView || $[6] !== intenseSpotlight || $[7] !== isUsingMouse) {
    t7 = t8 => {
      const {
        contextSafe
      } = t8;
      const spotlightEl = spotlightRef.current;
      const wave = waveRef.current;
      if (!spotlightEl || !wave) {
        return;
      }
      if (!isUsingMouse) {
        return;
      }
      if (!inView) {
        return;
      }
      let hovering = false;
      let spotTween = null;
      let waveTween = null;
      const spotlightPeak = intenseSpotlight ? 1 : 0.4;
      gsap.set(spotlightEl, {
        autoAlpha: 0
      });
      gsap.set(wave, {
        autoAlpha: WAVE_ENABLED ? spotlightPeak : 0
      });
      if (WAVE_ENABLED) {
        gsap.fromTo(wave, {
          "--wave-x": -30
        }, {
          "--wave-x": 130,
          duration: WAVE_DURATION,
          ease: "none",
          repeat: -1,
          repeatDelay: WAVE_INTERVAL
        });
      }
      const xTo = gsap.quickTo(spotlightEl, "--mx", QUICK_TO);
      const yTo = gsap.quickTo(spotlightEl, "--my", QUICK_TO);
      const enterHover = contextSafe(() => {
        if (hovering) {
          return;
        }
        hovering = true;
        spotTween?.kill();
        waveTween?.kill();
        spotTween = gsap.to(spotlightEl, {
          autoAlpha: spotlightPeak,
          ...SHOW
        });
        waveTween = gsap.to(wave, {
          autoAlpha: 0,
          ...HIDE
        });
      });
      const leaveHover = contextSafe(() => {
        if (!hovering) {
          return;
        }
        hovering = false;
        spotTween?.kill();
        waveTween?.kill();
        spotTween = gsap.to(spotlightEl, {
          autoAlpha: 0,
          ...HIDE
        });
        waveTween = gsap.to(wave, {
          autoAlpha: WAVE_ENABLED ? spotlightPeak : 0,
          ...SHOW
        });
      });
      const position = subscribeToMousePosition(t9 => {
        const {
          elementX,
          elementY,
          isWithinElement
        } = t9;
        if (!hovering) {
          xTo(elementX, elementX);
          yTo(elementY, elementY);
        } else {
          xTo(elementX);
          yTo(elementY);
        }
        if (isWithinElement) {
          enterHover();
        } else {
          leaveHover();
        }
      }, spotlightEl);
      return () => {
        position.unsubscribe();
      };
    };
    $[5] = inView;
    $[6] = intenseSpotlight;
    $[7] = isUsingMouse;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== inView || $[10] !== isUsingMouse) {
    t8 = [isUsingMouse, inView];
    $[9] = inView;
    $[10] = isUsingMouse;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      updateBehavior: "kill"
    };
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  useAnimation(t7, t8, t9);
  let t10;
  let t11;
  if ($[13] !== inView || $[14] !== isUsingMouse) {
    t10 = () => {
      if (!TIPS_ENABLED) {
        return;
      }
      const container_0 = containerRef.current;
      if (!container_0) {
        return;
      }
      if (!isUsingMouse) {
        return;
      }
      if (!inView) {
        return;
      }
      const svgEl = container_0.querySelector("svg");
      if (!svgEl) {
        return;
      }
      const svgBox = svgEl.parentElement;
      if (!svgBox) {
        return;
      }
      const viewBox = svgEl.viewBox.baseVal;
      const vbW = viewBox?.width || VIEWBOX_W;
      const vbH = viewBox?.height || VIEWBOX_H;
      const columns = Array.from(container_0.querySelectorAll("path")).map(_temp);
      let px = -9999;
      let py = -9999;
      let active = false;
      const update = () => {
        for (const col of columns) {
          let target = 0;
          if (active) {
            const dist = Math.hypot(px - col.cx, py - col.ty);
            const falloff = clamp(0, 1 - dist / TIP_RADIUS, 1);
            if (falloff > 0) {
              target = clamp(-TIP_MAX, (col.ty - py) * TIP_STRENGTH, TIP_MAX) * falloff;
            }
          }
          col.cur = col.cur + (target - col.cur) * TIP_LERP;
          if (Math.abs(col.cur - col.prev) > 0.01) {
            col.el.style.transform = `translateY(${col.cur}px)`;
            col.prev = col.cur;
          }
        }
      };
      const position_0 = subscribeToMousePosition(t12 => {
        const {
          elementX: elementX_0,
          elementY: elementY_0,
          elementW,
          elementH,
          isWithinElement: isWithinElement_0
        } = t12;
        if (!elementW || !elementH) {
          return;
        }
        active = isWithinElement_0;
        px = elementX_0 / elementW * vbW;
        py = elementY_0 / elementH * vbH;
      }, svgBox);
      gsap.ticker.add(update);
      return () => {
        gsap.ticker.remove(update);
        position_0.unsubscribe();
        for (const col_0 of columns) {
          col_0.el.style.transform = "";
        }
      };
    };
    t11 = [isUsingMouse, inView];
    $[13] = inView;
    $[14] = isUsingMouse;
    $[15] = t10;
    $[16] = t11;
  } else {
    t10 = $[15];
    t11 = $[16];
  }
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      updateBehavior: "kill"
    };
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  useAnimation(t10, t11, t12);
  let t13;
  if ($[18] !== Artwork || $[19] !== fill || $[20] !== intenseSpotlight) {
    t13 = !intenseSpotlight && <FaintLayer><LineIt fill={fill}><Artwork /></LineIt></FaintLayer>;
    $[18] = Artwork;
    $[19] = fill;
    $[20] = intenseSpotlight;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== Artwork) {
    t14 = <Artwork />;
    $[22] = Artwork;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== fill || $[25] !== t14) {
    t15 = <WaveLayer ref={waveRef}><LineIt fill={fill}>{t14}</LineIt></WaveLayer>;
    $[24] = fill;
    $[25] = t14;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== Artwork) {
    t16 = <Artwork />;
    $[27] = Artwork;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== fill || $[30] !== t16) {
    t17 = <SpotlightLayer ref={spotlightRef}><LineIt fill={fill}>{t16}</LineIt></SpotlightLayer>;
    $[29] = fill;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== color || $[33] !== fill || $[34] !== t13 || $[35] !== t15 || $[36] !== t17) {
    t18 = <LinesContainer ref={containerRef} color={color} fill={fill}>{t13}{t15}{t17}</LinesContainer>;
    $[32] = color;
    $[33] = fill;
    $[34] = t13;
    $[35] = t15;
    $[36] = t17;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  return t18;
}
// alt mode only: always-visible baseline underneath WaveLayer/SpotlightLayer,
// so un-spotlighted lines are faint rather than fully hidden
function _temp(el) {
  const box = el.getBBox();
  return {
    el,
    cx: box.x + box.width / 2,
    ty: box.y,
    cur: 0,
    prev: 0
  };
}
const FaintLayer = withComponent(Layer, FaintLayer___raw);
const SpotlightLayer = withComponent(Layer, SpotlightLayer___raw);
const WaveLayer = withComponent(Layer, WaveLayer___raw);